// for video demo when creating activity
// if user click "don't show this again" checkbox, then don't show this model again
import { Box, Button, Checkbox, Divider, Typography, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import { videoDontShowAgainKey } from '../../config/constants';
import StyledButton from '../Common/StyledButton';

interface IVideoDemoProps {
  closeModel: () => void;
  handleNext: () => void;
}

function VideoDemo({ closeModel, handleNext }: IVideoDemoProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const shouldShowVideoDemo = localStorage.getItem(videoDontShowAgainKey);
    if (shouldShowVideoDemo === 'true') {
      setDontShowAgain(true);
    }
  }, []);

  // Event handler for checkbox change
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDontShowAgain(event.target.checked);
    // Save to localStorage when the checkbox is checked
    if (event.target.checked) {
      localStorage.setItem(videoDontShowAgainKey, 'true');
    } else {
      localStorage.removeItem(videoDontShowAgainKey);
    }
  };

  return (
    <Grid item xs={12} display="flex" flexDirection="column" height="100%" p="32px" gap={4}>
      <Grid>
        <Box display="flex" justifyContent="space-between" mb="24px">
          <Typography variant="h4" color="primary.main">
            {t('activity.createActivity.videoDemo.welcomeToActivityBuilder')}
          </Typography>
          <Box onClick={closeModel}>
            <img
              src="/assets/icons/close-circle-large.svg"
              alt="close-icon"
              style={{
                cursor: 'pointer',
              }}
            />
          </Box>
        </Box>
        <Divider />
      </Grid>
      <Grid display="flex" justifyContent="center" width="100%" height="63%">
        <ReactPlayer
          url={`${process.env.REACT_APP_MEDIA_FILES_BASE_URL}/media/common-assets/videos/activity-create-demo.mp4`}
          controls
          data-testid="demo-video-player"
          width="100%"
          height="100%"
        />
      </Grid>
      <Divider />
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Checkbox
            checked={dontShowAgain}
            onChange={handleCheckboxChange}
            sx={{ padding: 0, margin: 0, color: (theme) => theme.palette.primary.main }}
            aria-labelledby="dont-show-again-label"
          />
          <Typography id="dont-show-again-label" variant="bodyRegular" color="primary.dark">
            {t('activity.createActivity.videoDemo.dontShowThisAgain')}
          </Typography>
        </Box>
        <StyledButton onClick={handleNext}>
          {t('activity.createActivity.videoDemo.startBuilding')}
        </StyledButton>
      </Box>
    </Grid>
  );
}

export default VideoDemo;
